import * as React from 'react';
import camelCase from 'lodash/camelCase';

import {
  IErrorMsgs,
  IInputAdornment,
  IInputControlTooltipProps,
  IInputError,
  IInputIconProps,
  IInputMaxWidth,
  IInputProps,
} from '../common';
import InputControl from '../InputControl/InputControl';

import TextInput from './Input';

export enum VALID_INPUT_TYPES {
  email = 'email',
  password = 'password',
  number = 'number',
  tel = 'tel',
  text = 'text',
  url = 'url',
}

export interface IInputFieldProps extends IErrorMsgs, IInputMaxWidth {
  helperText?: string | React.ReactNode;
  label: string;
  tooltipProps?: IInputControlTooltipProps;
}

export type InputTextFieldProps = IInputFieldProps & IInputProps & IInputError & IInputIconProps & IInputAdornment;

// exporting here is a work around for this issue https://github.com/microsoft/tslint-microsoft-contrib/issues/667
export const InputTextField = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement> & InputTextFieldProps>((
  props, ref
) => {
  const {
    adornment,
    errorMsgs,
    helperText,
    iconProps,
    inputProps,
    label,
    tooltipProps,
    maxWidth,
  } = props;
  const isDisabled = !!(inputProps && inputProps.disabled);
  const isReadOnly = !!(inputProps && inputProps.readOnly);
  const isOptional: boolean = !!(inputProps && inputProps.required === false);
  const inputId: string = camelCase(`${label}`);

  if (inputProps && inputProps.type && !(inputProps.type in VALID_INPUT_TYPES)) {
    throw new Error(`Type ${inputProps.type} is not a supported. Please only use supported types ${Object.values(VALID_INPUT_TYPES)}.`);
  }

  return (
    <InputControl
      errorMsgs={errorMsgs}
      helperText={helperText}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      isOptional={isOptional}
      label={label}
      tooltipProps={tooltipProps}
      maxWidth={maxWidth}
      inputProps={inputProps}
    >
      <TextInput
        adornment={adornment}
        inputProps={inputProps}
        id={inputId}
        iconProps={iconProps}
        ref={ref}
      />
    </InputControl>
  );
});

export default InputTextField;
